// extracted by mini-css-extract-plugin
export default {"container":"MySelect_container__UAQWw","flex":"MySelect_flex__UHACZ","label":"MySelect_label__phK+J","select":"MySelect_select__K7yiD","errorMessage":"MySelect_errorMessage__EO9ty"};